<template>
  <div class="model_specification">
    <div class="model_specification__header">
      <h4 class="title">
        {{ translate("specification.new") }}
      </h4>
    </div>

    <div class="model_specification__body">
      <div class="client_order">
        <div class="block">
          <div class="block_wrap">

            <div class="line">
              <div class="input_wrap main_name">
                <fg-input
                    v-model="primary_data.name"
                    type="text"
                    :label="translate('specification.name')"
                    :placeholder="translate('specification.name')"
                    :clearable="true"
                />
              </div>
            </div>

            <div class="line">
              <div class="form_select input_wrap parent_company">
                  <WrapDatePicker
                      type="date"
                      value_type="X"
                      v-model="primary_data.ts_date"
                      :range="false"
                      :confirm="false"
                      :disabled_date="['- 12 month', '+ 1 month']"
                      :placeholder="translate('specification.date')"
                      :label="translate('specification.date')"
                  />
              </div>

              <div class="input_wrap">
                <label>
                  {{ translate('specification.type') }}
                </label>
                <tree-select
                    :options="type_list"
                    :placeholder="translate('specification.type')"
                    v-model="primary_data.type"
                    :clearable="false"
                    :multiple="false"
                />
              </div>
            </div>

            <div class="line">
              <div class="input_wrap parent_company">
                <label>
                  {{ translate('specification.client') }}
                </label>
                <tree-select
                    :options="client_list"
                    :placeholder="translate('specification.client')"
                    v-model="primary_data.client_id"
                    :clearable="false"
                    :multiple="false"
                    @input="change_name"
                />
              </div>

              <div class="input_wrap parent_company">
                <label>
                  {{ translate('specification.user') }}
                </label>
                <tree-select
                    :options="company_user_list"
                    :placeholder="translate('specification.user')"
                    v-model="primary_data.customer_user_id"
                    :clearable="false"
                    :multiple="false"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="model_specification__footer">
      <span
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="create_specification"
      >
        {{ translate('btn.create') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </span>
    </div>

  </div>
</template>
<script>


import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'ClientOrderModal',
  components: {WrapDatePicker},
  data () {
    return {
      primary_data: {
        id: null,
        name: "",
        client_id: null,
        customer_user_id: null,
        ts_date: null,
        date: null,
        type: null,
      },
      loading: true,
      filter_link: null
    }
  },
  computed:{
    type_list(){
      return this.$store.getters.getClientOrderSpecs.types.map((entry) => {
        return {id: entry.id, label: entry.descr}
      })
    },
    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        return {label: client.name, id: client.id}
      })
    },

    company_user_list(){
      return this.$store.getters.getCompanyUserList.map((user) => {
        return {label: user.name, id: user.id}
      })
    },
  },

  methods: {
    change_name(){
      if (this.primary_data.client_id !== null){
        let client = this.client_list.find((item) => {
          if (item.id === this.primary_data.client_id) return item
        })
        this.primary_data.name = this.primary_data.name === "" ? this.primary_data.name = client.label : this.primary_data.name
      }
    },
    create_specification(){
      this.primary_data.date = this.getDateYYYMMDD(this.primary_data.ts_date)

      this.$http.v1.createSpecification(this.primary_data, (response) => {
        this.global_notify('info', this.translate('specification.saved_success'))
        this.update()
        this.$router.push({path: '/specification/' + response.data.id})
        this.close_modal()
      })
    },
    update(){
      this.$emit('update')
    },
    close_modal () {
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
  .model_specification{
    height: 100%;
    padding: 10px;
    &__header{
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      .title{
        width: 100%;
        margin: 0;
        text-align: center;
      }
      .links{
        width: 30%;
        & > .vue-treeselect{
          margin-bottom: 0;
        }
      }
    }
    &__body{
      width: 100%;
      //height: 100%;
      height: 600px;
      .client_order{
        width: 100%;
        height: 100%;
        .block{
          height: calc(100% - 35px);
          border: 1px solid #efe9e9;
          margin-top: -1px;
          padding: 10px;
          overflow-y: auto;
          .line{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .input_wrap{
              width: 100%;
              text-align: start;
              margin-bottom: 10px;
              display: flex;
              flex-direction: column;
              margin-right: 10px;
              &:last-child{
                margin-right: 0;
              }
              .form-control{

                width: 100%;
              }
            }
          }

          &::-webkit-scrollbar{
            width: 10px;
          }
        }
      }

    }
    &__footer{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      .btn{
        margin: 0 10px 0 0;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .pointer{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
  }
  .form-group,
  .vue-treeselect{
    margin-bottom: 0;
  }


</style>
